import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../Logo';

export const Header: React.FC = () => {
  return (
    <header className="relative text-white py-6 px-4 shadow-md">
      {/* Background Gradient + Image */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-blue-900 via-blue-700 to-blue-600 opacity-90"
      />
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: 'url(/images/misc/7.jpg)',
        }}
      />
      
      {/* Overlay Content */}
      <div className="relative max-w-4xl mx-auto flex items-center justify-between">
        {/* Logo and Text Section */}
        <Link to="/" className="flex items-center gap-4 hover:opacity-90 transition-opacity">
          <div className="w-14 h-14 flex-shrink-0">
            <Logo 
              width={56}
              height={56}
              className="object-contain"
            />
          </div>
          <div>
            <h1 className="text-3xl font-bold">Peptide Now</h1>
            <p className="text-blue-100 text-sm">Precision Vial Metrics Calculator</p>
          </div>
        </Link>
        
        {/* Link Button Section */}
        <Link
          to="/peptides"
          className="bg-white text-blue-600 px-6 py-2 rounded-md font-semibold hover:bg-blue-50 transition-colors shadow-sm text-sm md:text-base md:px-6 md:py-2"
        >
          Reliable Peptide Sources
        </Link>
      </div>
    </header>
  );
};
